export const POPULAR_TIME_LIST = [
  { label: '07:00 - 09:00 WIB', value: [7, 8, 9] },
  { label: '10:00 - 12:00 WIB', value: [10, 11, 12] },
  { label: '13:00 - 15:00 WIB', value: [13, 14, 15] },
  { label: '15:00 - 17:00 WIB', value: [15, 16, 17] },
];
